import { IconHistory } from '@tabler/icons-react'
import type { JSX } from 'react'
import { lastChipClass } from '#src/components/rich-text-editor/ObservationNode/observationChip.ts'

export interface LastValueChipProps {
  // The earlier value as shown: "Continent".
  text: string
  // When it was recorded, after the value: "Continent · Oct 6".
  date?: string | null
  ariaLabel: string
  onClick: () => void
  disabled?: boolean
  // Before the value: "Last: ".
  prefix?: string
  // A hover hint, such as where the value is from.
  title?: string
}

// An earlier value offered again after a field, as a muted chip that
// records it in one click.
export function LastValueChip({
  text,
  date,
  ariaLabel,
  onClick,
  disabled,
  prefix = '',
  title,
}: LastValueChipProps): JSX.Element {
  return (
    <button
      type="button"
      data-last-answer=""
      title={title}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      className={lastChipClass()}
    >
      <IconHistory className="size-3 shrink-0" aria-hidden />
      <span className="truncate">
        {prefix}
        {date ? `${text} · ${date}` : text}
      </span>
    </button>
  )
}
